import type { OrionIqEventName } from '@logz-pkg/analytics';
import { orionIqAnalyticsService } from 'services/analytics/orion-iq-analytics.service';

type DrawerEvent = OrionIqEventName<'OrionIQChatDrawer'>;

export interface IChatSurfaceContext {
  /** The ui-router state name the drawer is open on — a route PATTERN, never a resolved URL. */
  page: string;
  workspace: 'Open360' | 'SIEM';
}

let surface: IChatSurfaceContext | undefined;
let reportedSurfaces = new Set<string>();
let wasDrawerOpen = false;

const setContext = (next: IChatSurfaceContext): void => {
  surface = next;
};

const capture = (event: DrawerEvent, props?: Record<string, unknown>): void => {
  orionIqAnalyticsService.capture('OrionIQChatDrawer', event, { ...props, ...surface }).catch(() => undefined);
};

/** True the first time this surface is seen in this session, so the exposure event fires once per surface. */
const claimSurface = (key: string): boolean => {
  if (reportedSurfaces.has(key)) return false;

  reportedSurfaces.add(key);

  return true;
};

/** True on a closed->open transition. Held here rather than in a ref because the drawer host is remountable. */
const claimDrawerOpen = (isOpen: boolean): boolean => {
  const isEdge = isOpen && !wasDrawerOpen;

  wasDrawerOpen = isOpen;

  return isEdge;
};

const clearSession = (): void => {
  surface = undefined;
  reportedSurfaces = new Set();
  wasDrawerOpen = false;
};

export const orionChatAnalytics = { capture, setContext, claimSurface, claimDrawerOpen, clearSession };
